SET_USER_ACCOUNT_SUBSCRIPTION_PAYMENTS_PROCESSING